export default __webpack_public_path__ + "static/media/0x9d5565da88e596730522cbc5a918d2a89dbc16d9.4a03c8d1.webp";